export default __webpack_public_path__ + "static/media/portfolio.1f2ebb6f.png";